<template>
  <div></div>
</template>

<script>
export default {
  name: "AiAssistant",
  mounted() {
    this.$root.$emit("open-chat-widget");
    this.$router.replace({ name: "DashboardOverview" });
  },
};
</script>
